import { LeaveApprovalStatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class OTStatusRequest {
    @ApiProperty()
    otId: number;

    @ApiProperty()
    employeeCode: string;

    @ApiProperty()
    status: LeaveApprovalStatusEnum;

    @ApiProperty()
    updatedUser: string;
}